var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feed-filters-wrap" },
    [
      _c("transition", { attrs: { name: "filters-slide" } }, [
        _vm.open
          ? _c("div", { staticClass: "feed-filters" }, [
              _c("div", { staticClass: "feed-filters__header" }, [
                _c("h3", { staticClass: "feed-filters__title" }, [
                  _vm._v("Filter articles"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "feed-filters__close",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1 1l12 12M13 1L1 13",
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "feed-filters__body",
                  class: { "feed-filters__body--loading": _vm.filtersLoading },
                },
                [
                  _vm._l(_vm.filterGroups, function (group) {
                    return _c(
                      "div",
                      { key: group.id, staticClass: "ff-group" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "ff-group__header",
                            on: {
                              click: function ($event) {
                                return _vm.toggleGroup(group.id)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "ff-group__label" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(group.label) +
                                  "\n              "
                              ),
                              _vm.selectedCount(group.category)
                                ? _c(
                                    "span",
                                    { staticClass: "ff-group__count" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.selectedCount(group.category)
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "ff-group__chevron",
                                class: {
                                  "ff-group__chevron--open":
                                    _vm.expandedGroups[group.id],
                                },
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 12 8",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M1 1.5l5 5 5-5",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "group-expand" } }, [
                          _vm.expandedGroups[group.id]
                            ? _c(
                                "div",
                                { staticClass: "ff-group__body" },
                                [
                                  !group.children || !group.children.length
                                    ? _c(
                                        "div",
                                        { staticClass: "ff-group__empty" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.hasActiveFilters
                                                  ? "There are no options available for your current selected Jurisdiction."
                                                  : "No options available"
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : [
                                        group.children.length > 8
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.searchTerms[group.id],
                                                  expression:
                                                    "searchTerms[group.id]",
                                                },
                                              ],
                                              staticClass: "ff-group__search",
                                              attrs: {
                                                type: "text",
                                                placeholder: `Search ${group.label.toLowerCase()}...`,
                                              },
                                              domProps: {
                                                value:
                                                  _vm.searchTerms[group.id],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.searchTerms,
                                                    group.id,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ff-group__options" },
                                          _vm._l(
                                            _vm.filteredOptions(group),
                                            function (opt) {
                                              return _c(
                                                "div",
                                                {
                                                  key: opt.id,
                                                  staticClass: "ff-item",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ff-item__row",
                                                    },
                                                    [
                                                      opt.children &&
                                                      opt.children.length
                                                        ? _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "ff-item__expand",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.toggleNode(
                                                                      group.id,
                                                                      opt.id
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "svg",
                                                                {
                                                                  staticClass:
                                                                    "ff-item__expand-icon",
                                                                  class: {
                                                                    "ff-item__expand-icon--open":
                                                                      _vm.isNodeExpanded(
                                                                        group.id,
                                                                        opt.id
                                                                      ),
                                                                  },
                                                                  attrs: {
                                                                    width: "8",
                                                                    height: "8",
                                                                    viewBox:
                                                                      "0 0 8 8",
                                                                    fill: "none",
                                                                  },
                                                                },
                                                                [
                                                                  _c("path", {
                                                                    attrs: {
                                                                      d: "M2 1l4 3-4 3",
                                                                      stroke:
                                                                        "currentColor",
                                                                      "stroke-width":
                                                                        "1.5",
                                                                      "stroke-linecap":
                                                                        "round",
                                                                      "stroke-linejoin":
                                                                        "round",
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c("span", {
                                                            staticClass:
                                                              "ff-item__expand-spacer",
                                                          }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "ff-item__label",
                                                        },
                                                        [
                                                          _c("input", {
                                                            staticClass:
                                                              "ff-item__checkbox",
                                                            attrs: {
                                                              type: "checkbox",
                                                              disabled:
                                                                _vm.isDisabledByParent(
                                                                  group.category,
                                                                  opt.id
                                                                ),
                                                            },
                                                            domProps: {
                                                              checked:
                                                                _vm.isSelected(
                                                                  group.category,
                                                                  opt.id
                                                                ),
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                return _vm.toggleOption(
                                                                  group.category,
                                                                  opt.id,
                                                                  opt.label,
                                                                  opt.children
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ff-item__text",
                                                              class: {
                                                                "ff-item__text--disabled":
                                                                  _vm.isDisabledByParent(
                                                                    group.category,
                                                                    opt.id
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  opt.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "transition",
                                                    {
                                                      attrs: {
                                                        name: "group-expand",
                                                      },
                                                    },
                                                    [
                                                      opt.children &&
                                                      opt.children.length &&
                                                      _vm.isNodeExpanded(
                                                        group.id,
                                                        opt.id
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ff-item__children",
                                                            },
                                                            _vm._l(
                                                              opt.children,
                                                              function (child) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: child.id,
                                                                    staticClass:
                                                                      "ff-item",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "ff-item__row",
                                                                      },
                                                                      [
                                                                        child.children &&
                                                                        child
                                                                          .children
                                                                          .length
                                                                          ? _c(
                                                                              "button",
                                                                              {
                                                                                staticClass:
                                                                                  "ff-item__expand",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      $event.stopPropagation()
                                                                                      return _vm.toggleNode(
                                                                                        group.id,
                                                                                        child.id
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "svg",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ff-item__expand-icon",
                                                                                    class:
                                                                                      {
                                                                                        "ff-item__expand-icon--open":
                                                                                          _vm.isNodeExpanded(
                                                                                            group.id,
                                                                                            child.id
                                                                                          ),
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        width:
                                                                                          "8",
                                                                                        height:
                                                                                          "8",
                                                                                        viewBox:
                                                                                          "0 0 8 8",
                                                                                        fill: "none",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "path",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            d: "M2 1l4 3-4 3",
                                                                                            stroke:
                                                                                              "currentColor",
                                                                                            "stroke-width":
                                                                                              "1.5",
                                                                                            "stroke-linecap":
                                                                                              "round",
                                                                                            "stroke-linejoin":
                                                                                              "round",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "ff-item__expand-spacer",
                                                                              }
                                                                            ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "label",
                                                                          {
                                                                            staticClass:
                                                                              "ff-item__label",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                staticClass:
                                                                                  "ff-item__checkbox",
                                                                                attrs:
                                                                                  {
                                                                                    type: "checkbox",
                                                                                    disabled:
                                                                                      _vm.isDisabledByParent(
                                                                                        group.category,
                                                                                        child.id
                                                                                      ),
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    checked:
                                                                                      _vm.isSelected(
                                                                                        group.category,
                                                                                        child.id
                                                                                      ) ||
                                                                                      _vm.isDisabledByParent(
                                                                                        group.category,
                                                                                        child.id
                                                                                      ),
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.toggleOption(
                                                                                        group.category,
                                                                                        child.id,
                                                                                        child.label,
                                                                                        child.children
                                                                                      )
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "ff-item__text",
                                                                                class:
                                                                                  {
                                                                                    "ff-item__text--disabled":
                                                                                      _vm.isDisabledByParent(
                                                                                        group.category,
                                                                                        child.id
                                                                                      ),
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    child.label
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "transition",
                                                                      {
                                                                        attrs: {
                                                                          name: "group-expand",
                                                                        },
                                                                      },
                                                                      [
                                                                        child.children &&
                                                                        child
                                                                          .children
                                                                          .length &&
                                                                        _vm.isNodeExpanded(
                                                                          group.id,
                                                                          child.id
                                                                        )
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "ff-item__children",
                                                                              },
                                                                              _vm._l(
                                                                                child.children,
                                                                                function (
                                                                                  grandchild
                                                                                ) {
                                                                                  return _c(
                                                                                    "div",
                                                                                    {
                                                                                      key: grandchild.id,
                                                                                      staticClass:
                                                                                        "ff-item",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ff-item__row",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "span",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ff-item__expand-spacer",
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "label",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ff-item__label",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "input",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ff-item__checkbox",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      type: "checkbox",
                                                                                                      disabled:
                                                                                                        _vm.isDisabledByParent(
                                                                                                          group.category,
                                                                                                          grandchild.id
                                                                                                        ),
                                                                                                    },
                                                                                                  domProps:
                                                                                                    {
                                                                                                      checked:
                                                                                                        _vm.isSelected(
                                                                                                          group.category,
                                                                                                          grandchild.id
                                                                                                        ) ||
                                                                                                        _vm.isDisabledByParent(
                                                                                                          group.category,
                                                                                                          grandchild.id
                                                                                                        ),
                                                                                                    },
                                                                                                  on: {
                                                                                                    change:
                                                                                                      function (
                                                                                                        $event
                                                                                                      ) {
                                                                                                        return _vm.toggleOption(
                                                                                                          group.category,
                                                                                                          grandchild.id,
                                                                                                          grandchild.label,
                                                                                                          null
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "span",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "ff-item__text",
                                                                                                  class:
                                                                                                    {
                                                                                                      "ff-item__text--disabled":
                                                                                                        _vm.isDisabledByParent(
                                                                                                          group.category,
                                                                                                          grandchild.id
                                                                                                        ),
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      grandchild.label
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  !_vm.filterGroups.length
                    ? _c("div", { staticClass: "feed-filters__loading" }, [
                        _vm._v("\n          Loading filters...\n        "),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "feed-filters__footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "feed-filters__apply",
                    on: { click: _vm.applyFilters },
                  },
                  [
                    _vm._v("\n          Apply filters\n          "),
                    _vm.totalSelected
                      ? _c(
                          "span",
                          { staticClass: "feed-filters__apply-count" },
                          [_vm._v("(" + _vm._s(_vm.totalSelected) + ")")]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _vm.hasActiveFilters
                  ? _c(
                      "button",
                      {
                        staticClass: "feed-filters__reset",
                        on: { click: _vm.resetFilters },
                      },
                      [_vm._v("\n          Clear all\n        ")]
                    )
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }